module.exports = __webpack_public_path__ + "static/media/badge-icon.807b471e.svg";